import { API, graphqlOperation } from 'aws-amplify';

const fields = `id userID type title body link isRead createdAt updatedAt`;

const LIST_BY_USER = /* GraphQL */ `
  query MemberNotificationsByUser($userID: ID!, $sortDirection: ModelSortDirection, $limit: Int, $nextToken: String) {
    notificationsByUser(userID: $userID, sortDirection: $sortDirection, limit: $limit, nextToken: $nextToken) {
      items { ${fields} }
      nextToken
    }
  }
`;

const CREATE = /* GraphQL */ `
  mutation MemberCreateNotification($input: CreateUserNotificationInput!) {
    createUserNotification(input: $input) { ${fields} }
  }
`;

const UPDATE = /* GraphQL */ `
  mutation MemberUpdateNotification($input: UpdateUserNotificationInput!) {
    updateUserNotification(input: $input) { ${fields} }
  }
`;

const DELETE = /* GraphQL */ `
  mutation MemberDeleteNotification($input: DeleteUserNotificationInput!) {
    deleteUserNotification(input: $input) { id }
  }
`;

const run = async (query, variables = {}) => {
  const response = await API.graphql(graphqlOperation(query, variables));
  return response.data;
};

const duplicateError = (error) => (error?.errors || []).some(({ errorType, message }) =>
  errorType === 'DynamoDB:ConditionalCheckFailedException' || /conditional|already exists/i.test(message || ''));

export const notificationApi = {
  listByUser: async (userID) => {
    let nextToken = null;
    const items = [];
    do {
      const data = await run(LIST_BY_USER, { userID, sortDirection: 'DESC', limit: 100, nextToken });
      const page = data.notificationsByUser;
      items.push(...(page?.items || []).filter(Boolean));
      nextToken = page?.nextToken || null;
    } while (nextToken);
    return items;
  },

  create: async (input) => {
    try {
      const data = await run(CREATE, { input: { ...input, isRead: false, createdAt: input.createdAt || new Date().toISOString() } });
      return data.createUserNotification;
    } catch (error) {
      if (duplicateError(error)) return null;
      throw error;
    }
  },

  markRead: async (id) => {
    const data = await run(UPDATE, { input: { id, isRead: true } });
    return data.updateUserNotification;
  },

  remove: async (id) => {
    const data = await run(DELETE, { input: { id } });
    return data.deleteUserNotification;
  },
};
